import { Injectable, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppState } from '../../model/reducer';
import { ParsedBundle } from './bundle.model';
import { BundleGroup } from './bundle-group.model';
import { bundlesView } from '../reducers/view';
import { BundleManagementHelper } from './bundle-management.helper';
import { superAdminView } from '../../model/views';
import { deleteBundle, loadBundles, uploadBundles } from '../reducers/bundle-management.actions';

@Injectable()
export class BundleManagementContext {
  private store$ = inject<Store<AppState>>(Store);

  bundleGroups$: Observable<BundleGroup[]>;
  bundleUploadPermitted$: Observable<boolean>;

  constructor() {
    this.bundleGroups$ = this.store$.pipe(select(bundlesView), map((bundles: ParsedBundle[]) => BundleManagementHelper.createBundleGroups(bundles)));
    this.bundleUploadPermitted$ = this.store$.pipe(select(superAdminView));
  }

  loadBundles(): void {
    this.store$.dispatch(loadBundles());
  }

  uploadBundles(files: File[]): void {
    this.store$.dispatch(uploadBundles({files}));
  }

  deleteBundle(bundle: ParsedBundle): void {
    this.store$.dispatch(deleteBundle({bundle}));
  }
}
